import { useState } from 'react';
import { Link } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';

import { api, consulta } from '../api/cliente';
import type { Pagina } from '../api/cliente';
import type { LeadResumen } from '../api/tipos';
import {
  Aviso,
  Cargando,
  Encabezado,
  Etiqueta,
  Paginador,
  Seleccion,
  Tarjeta,
  Vacio,
  fechaHora,
} from '../ui/piezas';

const ESTADOS = [
  'NUEVO',
  'CONTACTADO',
  'CALIFICADO',
  'VISITA_AGENDADA',
  'NEGOCIACION',
  'GANADO',
  'PERDIDO',
  'DESCARTADO',
];

export default function Solicitudes() {
  const [estado, setEstado] = useState('');
  const [sinAsignar, setSinAsignar] = useState('false');
  const [pagina, setPagina] = useState(0);

  const listado = useQuery({
    queryKey: ['leads', estado, sinAsignar, pagina],
    queryFn: () =>
      api<Pagina<LeadResumen>>(
        `/admin/leads${consulta({ estado, sinAsignar, page: pagina, size: 25 })}`,
      ),
  });

  const filas = listado.data?.content ?? [];

  return (
    <>
      <Encabezado
        titulo="Solicitudes"
        nota="Lo que entra por el portal. Lo sin asignar es lo que hay que repartir primero."
      />

      <Aviso error={listado.error} />

      <Tarjeta>
        <div className="rejilla" style={{ marginBottom: 16 }}>
          <Seleccion
            etiqueta="Estado"
            valor={estado}
            alCambiar={(v) => {
              setEstado(v);
              setPagina(0);
            }}
            vacio="Todos"
            opciones={ESTADOS.map((e) => ({
              valor: e,
              texto: e.replaceAll('_', ' ').toLowerCase(),
            }))}
          />
          <Seleccion
            etiqueta="Asignación"
            valor={sinAsignar}
            alCambiar={(v) => {
              setSinAsignar(v);
              setPagina(0);
            }}
            opciones={[
              { valor: 'false', texto: 'Todas' },
              { valor: 'true', texto: 'Solo sin asignar' },
            ]}
          />
        </div>

        {listado.isPending ? (
          <Cargando />
        ) : filas.length === 0 ? (
          <Vacio>
            No hay solicitudes con esos filtros. Cuando alguien escriba desde el portal, aparece
            aquí.
          </Vacio>
        ) : (
          <div className="tabla-marco">
            <table>
              <thead>
                <tr>
                  <th>Quién</th>
                  <th>Contacto</th>
                  <th>Sobre</th>
                  <th>Interés</th>
                  <th>Estado</th>
                  <th>Asesor</th>
                  <th>Último contacto</th>
                </tr>
              </thead>
              <tbody>
                {filas.map((l) => (
                  <tr key={l.id}>
                    <td>
                      <Link to={`/solicitudes/${l.id}`}>{l.nombre}</Link>
                      <div>
                        <small style={{ opacity: 0.7 }}>{fechaHora(l.creadoEn)}</small>
                      </div>
                    </td>
                    <td>{l.contacto ?? '—'}</td>
                    <td>{l.asunto}</td>
                    <td>{l.interes.toLowerCase()}</td>
                    <td>
                      <Etiqueta>{l.estado}</Etiqueta>
                    </td>
                    <td>
                      {l.agente ?? <span style={{ color: '#B77714' }}>sin asignar</span>}
                    </td>
                    <td>{fechaHora(l.ultimoContactoEn)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}

        <Paginador
          pagina={listado.data?.number ?? 0}
          total={listado.data?.totalElements ?? 0}
          paginas={listado.data?.totalPages ?? 0}
          alCambiar={setPagina}
        />
      </Tarjeta>
    </>
  );
}
